export default __webpack_public_path__ + "static/agenda_screenshot_retina-1-4d2529bcc6307342bf982e0c39dc5253.png";